module.exports = __webpack_public_path__ + "static/img/test.5a66e39.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/test.svg
// module id = oi6v
// module chunks = 1